import { Component } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";
import { TranslationService } from "../../_services/translation.service";

@Component({
  selector: "dev-disable-scroll-input",
  template: `
    <div
      id="dev-disable-scroll-input"
      dir="rtl"
      class="h-screen w-screen flex flex-row justify-center items-start"
    >
      <div class="p-4">
        <input class="text-4xl" type="number" />
      </div>
    </div>
  `,
  styleUrls: ["../../../css/tailwind-utils.scss"],
})
export class DevDisableScrollInputComponent {
  // @ViewChild("multiSelectCircles")
  // public multiSelectCircles: MultiSelectNestsComponent;
  public translations$: Observable<ITranslations>;

  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }
}



// WEBPACK FOOTER //
// ./src/app/development/ui/dev-disable-scroll-input.component.ts